// @flow
import React, { Component, Fragment } from "react";
import HomeSlider from "../containers/HomeSlider";
// import ProductWidgets from "../components/ProductWidgets";
import Services from "../containers/Services";
import TopCategories from "../containers/TopCategories";
import ProductsSlider from "../containers/ProductsSlider";
import { withRouter } from "react-router";
import AppHeader from "../containers/AppHeader";
//import { useTranslation } from 'react-i18next';

class HomeView extends Component {

    render() {
        const { settings } = this.props;
     
 
        return (
            <Fragment>
                <AppHeader settings={settings} />
                <div className="offcanvas-wrapper">
                    <HomeSlider />
                    <TopCategories />
                    <ProductsSlider isFeatured={true} count="5" />
                    {/* <ProductWidgets /> */}
                    <Services />
                </div>
            </Fragment>
        );
    }
}

export default withRouter(HomeView)

